import type { BulkUserRow } from '@/types/bulkUserImport';
import { serializeBulkUserCsv } from './serializeBulkUserCsv';

export function buildBulkUserExportFilename(sourceFileName: string | null): string {
  if (sourceFileName?.trim()) {
    const base = sourceFileName.trim().replace(/\.csv$/i, '');
    return `${base}-export.csv`;
  }

  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  return `bulk-users-${day}-${month}-${d.getFullYear()}.csv`;
}

/** Download the current table rows as a CSV file (includes in-progress edits). */
export function downloadBulkUserCsv(rows: BulkUserRow[], sourceFileName: string | null = null): void {
  if (rows.length === 0) return;

  const csv = serializeBulkUserCsv(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = buildBulkUserExportFilename(sourceFileName);
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
